import { render } from "./IosCardDe.vue?vue&type=template&id=821d610e&scoped=true"
import script from "./IosCardDe.vue?vue&type=script&lang=js"
export * from "./IosCardDe.vue?vue&type=script&lang=js"

import "./IosCardDe.vue?vue&type=style&index=0&id=821d610e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821d610e"]])

export default __exports__